export default {
  title: 'Who is this order for? 😊',
  description: 'This helps us create a smooth experience.',
  form: {
    first_name: {
      placeholder: 'First name',
    },
  },
};